import { useCallback } from "react";

import useClient from "hooks/useClient";

export type OrderSheetKind = "draft" | "issued";

const useDownloadOrderSheetPdf = (): {
  download: (optionId: string, serviceId: string, estimateId: string, kind: OrderSheetKind) => Promise<Attachment>;
} => {
  const { client } = useClient();

  const download = useCallback(
    async (optionId: string, serviceId: string, estimateId: string, kind: OrderSheetKind) => {
      const { data } = await client<Attachment, unknown>({
        method: "get",
        url: `/option/${optionId}/request-service/${serviceId}/estimate/${estimateId}/download-order-sheet?kind=${kind}`,
      });
      return data;
    },
    [client]
  );

  return { download };
};

export default useDownloadOrderSheetPdf;
